import { injectable } from 'inversify';
import { Activator, Controller, resolve } from '../../Container';
import { NetOverlay } from './NetOverlay';

@injectable()
export class NetController extends Controller {

    @resolve(Activator) private activate!: Activator;

    public start(): void {
        this.burden(this.activate.call(NetOverlay).init());
    }
}
